import { useCallback, useEffect, useRef, useState } from "react";

export default function useAfterCall<TParams extends Array<any>>(action: (...params: TParams) => any) {
    const callFunctionsArray = useRef<(() => void)[]>([]).current;
    const [_switch, _setSwitch] = useState(false);

    useEffect(() => {
        callFunctionsArray.forEach(f => f());
        callFunctionsArray.splice(0, callFunctionsArray.length);
    }, [_switch])

    const handleCallAction = useCallback((...params: TParams) => {
        _setSwitch(!_switch);
        callFunctionsArray.push(() => action(...params));
    }, [action])

    return handleCallAction;
}